import {Injectable} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {
    CreateFromTemplateRequest,
    TemplateActionResponse,
    UpdateTemplateRequest
} from "../../model/dto/api/campaign-template.interface";
import {CampaignTemplateDto} from "../../model/dto/entity/campaign-template.dto";

/**
 * Service for CampaignTemplate entity operations.
 * F-013: Campaign Templates - Provides API access for template management.
 */
@Injectable({
    providedIn: 'root'
})
export class CampaignTemplateService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/ct/campaignTemplates')
    }

    getObjectIcon(): string {
        return 'fa-solid fa-file-lines';
    }

    /**
     * Creates a new campaign from a template.
     * F-013: Acceptance Criteria - "Given a template is selected, when campaign is created,
     * then all template settings are pre-populated"
     */
    createCampaignFromTemplate(request: CreateFromTemplateRequest): Observable<TemplateActionResponse> {
        return this.postGeneric<TemplateActionResponse>(request, '/createCampaign');
    }

    /**
     * Updates a template.
     * F-013: Acceptance Criteria - "Given a template needs updating, when edited,
     * then existing campaigns are not affected but new ones use updated version"
     */
    updateTemplate(templateId: number, request: UpdateTemplateRequest): Observable<TemplateActionResponse> {
        return this.http.put<TemplateActionResponse>(`${this.getApiUrl()}/${templateId}/update`, request);
    }

    /**
     * Deactivates a template (soft delete).
     */
    deactivateTemplate(templateId: number): Observable<TemplateActionResponse> {
        return this.postGeneric<TemplateActionResponse>({}, `/${templateId}/deactivate`);
    }

    /**
     * Gets all active templates.
     * F-013: Acceptance Criteria - "Given templates exist, when creating new campaign,
     * then user can select from available templates"
     */
    getActiveTemplates(): Observable<CampaignTemplateDto[]> {
        return this.getGeneric<CampaignTemplateDto[]>('/active');
    }

    /**
     * Gets all public templates.
     */
    getPublicTemplates(): Observable<CampaignTemplateDto[]> {
        return this.getGeneric<CampaignTemplateDto[]>('/public');
    }

    /**
     * Gets templates by campaign type.
     */
    getTemplatesByCampaignType(campaignType: string): Observable<CampaignTemplateDto[]> {
        return this.getGeneric<CampaignTemplateDto[]>(`/byType/${campaignType}`);
    }

    /**
     * Gets the count of campaigns created from a template.
     */
    getCampaignCount(templateId: number): Observable<number> {
        return this.getGeneric<number>(`/${templateId}/campaignCount`);
    }
}
